// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__OASmL","footer":"ModalUpdate_footer__1jmTI"};